import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
const FormItem = React.forwardRef((props, ref) => {
  const {
    children,
    label,
    labelClass,
    errorMessage,
    invalid,
    className,
    asterisk,
    extra,
    htmlFor,
  } = props;

  const formItemClass = classNames(
    "form-item",
    "w-full",

    className,
    invalid ? "invalid" : ""
  );
  const formLabelClass = classNames("form-label mb-1", labelClass);

  return (
    <div ref={ref} className={formItemClass}>
      <label htmlFor={htmlFor} className={formLabelClass}>
        {asterisk && <span className="text-red-500 mr-1">*</span>}
        {label}
        {extra && <span>{extra}</span>}
      </label>
      <div className={"relative w-full"}>
        {children}
        {invalid && (
          <span className="text-red-500 text-[13px]">{errorMessage}</span>
        )}
      </div>
    </div>
  );
});
FormItem.propTypes = {
  labelWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  errorMessage: PropTypes.string,
  invalid: PropTypes.bool,
  asterisk: PropTypes.bool,
  extra: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  htmlFor: PropTypes.string,
  labelClass: PropTypes.string,
};

export default FormItem;
